import axios from 'axios';

// Mirror App.js base-URL resolution so admin calls hit the same backend.
export const SERVER_URL = process.env.REACT_APP_API_BASE_URL
  ? `${process.env.REACT_APP_API_BASE_URL}/`
  : (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : '/api/');

// Current identity for the local-dev fallback (prod uses the JWT injected by nginx).
function currentUser() {
  return (
    localStorage.getItem('userinfo') ||
    localStorage.getItem('userEmail') ||
    ''
  );
}

function withUser(params = {}) {
  const u = currentUser();
  const search = new URLSearchParams(params);
  if (u) search.set('userEmail', u);
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

function dateParams(start, end) {
  const p = {};
  if (start) p.start = start;
  if (end) p.end = end;
  return p;
}

// ── Role / user management ──────────────────────────────────────────────
export async function getMe() {
  const res = await axios.get(`${SERVER_URL}admin/me${withUser()}`);
  return res.data;
}

export async function listUsers(search = '') {
  const res = await axios.get(`${SERVER_URL}admin/users${withUser(search ? { search } : {})}`);
  return res.data;
}

export async function createUser(payload) {
  const res = await axios.post(`${SERVER_URL}admin/users${withUser()}`, payload);
  return res.data;
}

export async function updateUser(id, payload) {
  const res = await axios.patch(`${SERVER_URL}admin/users/${encodeURIComponent(id)}${withUser()}`, payload);
  return res.data;
}

// ── Analytics ───────────────────────────────────────────────────────────
export async function getOverview(start, end) {
  const res = await axios.get(`${SERVER_URL}analytics/overview${withUser(dateParams(start, end))}`);
  return res.data;
}

export async function getMonthly(start, end) {
  const res = await axios.get(`${SERVER_URL}analytics/monthly${withUser(dateParams(start, end))}`);
  return res.data;
}

export async function getByUser(start, end, limit = 50) {
  const res = await axios.get(`${SERVER_URL}analytics/by-user${withUser({ ...dateParams(start, end), limit })}`);
  return res.data;
}

export async function getFeedback(start, end) {
  const res = await axios.get(`${SERVER_URL}analytics/feedback${withUser(dateParams(start, end))}`);
  return res.data;
}
